//
// Copyright (c) 2011-2024 by Curalate, Inc.
//
import { INgRedux } from 'ng-redux';

import { facebookInstagramSettingsActions } from '@account-settings/redux/facebook-instagram/facebookInstagramSettingsActions';

import curalateModule from 'app/curalate.module';
import template from 'app/dashboard/dashboard-page/dashboard-page.html';

import 'app/components/nav3/top-navigation-refreshed';
import { setNgRedux } from '@react-bridge/redux-bridge';

export class DashboardPage {
  constructor(private readonly $ngRedux: INgRedux) {
    setNgRedux($ngRedux);
  }

  public $onInit() {
    // So many of our components use these settings, that we should try to load them immediately.
    this.$ngRedux.dispatch(facebookInstagramSettingsActions.loadConnections());
  }
}

curalateModule.component('dashboardPage', {
  template,
  controller: ['$ngRedux', DashboardPage],
});
